(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soodox-first-period-support"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
const button=event.target.closest('[data-first-period-play]');
if(!button)return;
const video=button.parentElement.querySelector('video');
document.querySelectorAll('.first-period-support video').forEach(function(other){if(other!==video)other.pause();});
if(!video.getAttribute('src'))video.src=video.dataset.source;
video.controls=true;button.hidden=true;
video.play().catch(function(){button.hidden=false;});
});
document.addEventListener('toggle',function(event){if(event.target.matches('.first-period-support__video-details')&&!event.target.open)event.target.querySelectorAll('video').forEach(function(video){video.pause();});},true);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soodox-responsive-slideshow"] && !Shopify.designMode) return;
  try {
    
(()=>{
const init=()=>document.querySelectorAll('.sx-hero:not([data-sx-ready])').forEach(root=>{
root.dataset.sxReady='true';
const slides=[...root.querySelectorAll('[data-sx-slide]')],pause=root.querySelector('[data-sx-pause]'),reduce=matchMedia('(prefers-reduced-motion:reduce)'),mobile=matchMedia('(max-width:749px)');
let index=0,timer,paused=reduce.matches,hovered=false,focused=false,visible=true;
const media=()=>slides.forEach((slide,i)=>{const video=slide.querySelector('video');if(!video)return;const src=mobile.matches?video.dataset.mobile:video.dataset.desktop;if(video.getAttribute('src')!==src){video.src=src;video.removeAttribute('data-playing');}if(i===index&&!paused&&visible&&!document.hidden){video.muted=true;video.play().catch(()=>{});}else video.pause();});
root.querySelectorAll('video').forEach(v=>v.addEventListener('playing',()=>v.setAttribute('data-playing','')));
const schedule=()=>{clearTimeout(timer);if(root.dataset.autoplay==='true'&&!paused&&!hovered&&!focused&&visible&&!document.hidden&&slides.length>1)timer=setTimeout(()=>show((index+1)%slides.length),Math.max(3000,Number(root.dataset.interval)||3000));};
const show=n=>{index=(n+slides.length)%slides.length;slides.forEach((slide,i)=>{slide.hidden=i!==index;});media();schedule();};
pause.addEventListener('click',()=>{paused=!paused;if(!paused){hovered=false;focused=false;}pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?'Play slideshow':'Pause slideshow');media();schedule();});
root.addEventListener('mouseenter',()=>{hovered=true;schedule();});
root.addEventListener('mouseleave',()=>{hovered=false;schedule();});
root.addEventListener('focusin',()=>{focused=true;schedule();});
root.addEventListener('focusout',event=>{focused=root.contains(event.relatedTarget);schedule();});
root.addEventListener('keydown',event=>{if(event.key==='ArrowLeft'){event.preventDefault();show(index-1);}if(event.key==='ArrowRight'){event.preventDefault();show(index+1);}});
document.addEventListener('visibilitychange',()=>{media();schedule();});
new IntersectionObserver(entries=>{visible=entries[0].isIntersecting;media();schedule();},{threshold:.1}).observe(root);
mobile.addEventListener('change',media);
reduce.addEventListener('change',()=>{if(reduce.matches){paused=true;pause.textContent='▶';pause.setAttribute('aria-label','Play slideshow');media();schedule();}});
if(paused){pause.textContent='▶';pause.setAttribute('aria-label','Play slideshow');}
show(0);
});
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
document.addEventListener('shopify:section:load',init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["soodox-women-related"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',event=>{const button=event.target.closest('[data-women-return-buy]');if(!button)return;const target=document.querySelector('.soodox-women-product .product-form__submit');if(target){target.scrollIntoView({behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth',block:'center'});target.focus({preventScroll:true});}});

  } catch(e) { console.error(e); }
})();
})();
